import { SmallText } from "@sb1/ffe-core-react";
import { formatPercentage } from "@sb1/ffe-formatters";
import classNames from "classnames";
import type { CSSProperties } from "react";
import { FormattedMessage } from "react-intl";

interface Props {
	value: number;
	max: number;
	darkBG?: boolean;
	className?: string;
}

const Progressbar = ({ value, max, darkBG, className }: Props) => {
	if (value < 0) {
		throw new Error("Value can't be less than 0");
	} else if (value > max) {
		throw new Error("Value can't be greater than max");
	}

	return (
		<div className={classNames("ppm-progressbar", className)}>
			<SmallText className={classNames("ppm-margin-bottom--8", { "ppm-portal-white-text": darkBG })}>
				<FormattedMessage
					id="kjop.progressbar.prosent"
					description="Hvor mange prosent fullført baren er"
					defaultMessage="{prosent} fullført"
					values={{ prosent: formatPercentage((value / max) * 100, { maxDecimals: 0 }) }}
				/>
			</SmallText>
			<div className={classNames("ppm-progressbar__container", { "ppm-progressbar__container--darkBG": darkBG }, "ppm-dm-bg--lysgraa")}>
				<span
					className={classNames("ppm-progressbar__element", { "ppm-progressbar__element--darkBG": darkBG }, "ppm-dm-bg--vann-70")}
					style={{ "--prosent": `${(value / max) * 100}%` } as CSSProperties}
				/>
			</div>
		</div>
	);
};
export default Progressbar;
